import dateIncrements from './dateIncrements';  

const addColDurations = (date, mode, units) => {
  const { bottomType, quantity } = dateIncrements[mode];
  return date.plus({ [bottomType]: units * quantity });
};

export default addColDurations;
